<template>
  <section>
    <ModalVue
      :isPasswordConfirmOpen="isModalOpen"
      :closePasswordConfirm="handleModalState"
      :clickOutClose="!actionLoading"
      :isModal="true"
      :title="translateText(`${title}`)"
      :headerImg="headerImg"
    >
      <div class="my-4">
        <p class="mb-5 text-[#545454] text-sm font-normal leading-6">
          {{ translateText(`${message}`) }}
          <span v-if="messageSuffix" class="font-semibold">
            {{ messageSuffix }}
          </span>
        </p>

        <div class="flex items-center gap-2">
          <ButtonVue
            @handleClick="handleModalState"
            theme="greyOutline"
            size="medium"
            radius="small"
          >
            <p class="text-base font-medium text-gray-700">
              {{ translateText("groups.cancel") }}
            </p></ButtonVue
          >
          <ButtonVue
            @click="runConfirmationAction"
            :theme="resolvedConfirmButtonTheme"
            size="medium"
            radius="small"
            :disabled="actionLoading"
          >
            <ClipLoaderVue v-if="actionLoading" color="white" :size="12" />
            <p v-else class="text-base font-medium text-white">
              {{ translateText(confirmButtonTextKey) }}
            </p></ButtonVue
          >
        </div>
      </div>
    </ModalVue>
  </section>
</template>

<script>
import { successToast, translateText } from "@/core/helpers/utility";

export default {
  name: "GeneralConfirmationModal",
  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
    },
    refreshRecords: {
      type: Function,
      required: false,
      default: null,
    },
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    messageSuffix: {
      type: String,
      required: false,
      default: "",
    },
    handleModalState: {
      type: Function,
      required: true,
    },
    confirmAction: {
      type: Function,
      required: true,
    },
    confirmButtonTextKey: {
      type: String,
      required: false,
      default: "groups.delete",
    },
    confirmButtonTheme: {
      type: String,
      required: false,
      default: "",
    },
    successMessageKey: {
      type: String,
      required: false,
      default: "groups.successDelete",
    },
    headerImg: {
      type: String,
      required: false,
      default: "delete-red-bg.svg",
    },
    useApiSuccessMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSuccessToast: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      translateText,
      actionLoading: false,
    };
  },
  computed: {
    resolvedConfirmButtonTheme() {
      if (this.confirmButtonTheme) {
        return this.confirmButtonTheme;
      }

      const translatedText = translateText(this.confirmButtonTextKey) || "";
      const hasDeleteText =
        this.confirmButtonTextKey?.toLowerCase().includes("delete") ||
        translatedText.toLowerCase().includes("delete");

      return hasDeleteText ? "danger" : "positiveSolid";
    },
  },
  methods: {
    async runConfirmationAction() {
      this.actionLoading = true;

      try {
        const response = await this.confirmAction();
        const successMessage = this.useApiSuccessMessage
          ? response?.data?.message
          : null;

        if (this.showSuccessToast) {
          successToast(successMessage || translateText(this.successMessageKey));
        }

        if (typeof this.refreshRecords === "function") {
          await this.refreshRecords();
        }

        this.handleModalState();
      } finally {
        this.actionLoading = false;
      }
    },
  },
};
</script>

<style></style>
